module.exports = __webpack_public_path__ + "img/Bach.9c945637.jpg";